import { gql, GraphQLClient } from 'graphql-request';
import { endPoint, merchantServiceGraphql, tokenAppGraphql, userToken } from '../config/Config';

export const getListSubMerchant = async (data) => {
    try {
        const EMPLOYEE = gql`
        query Employee($employeeId: Int) {
            Employee(id: $employeeId) {
              SubMerchant {
                id
                name
              }
            }
          }
        `
        const respone = await merchantServiceGraphql.request(EMPLOYEE, data);
        return respone.Employee
    } catch(err) {
        return null;
    }
}

export const updateStatusEmployee = async (data, password) => {
  const UPDATE_STATUS_MERCHANT = gql`
    mutation UpdateStatusEmployee($updateStatusEmployeeId: Int!, $status: Int!) {
      updateStatusEmployee(id: $updateStatusEmployeeId, status: $status) {
        id
        status
      }
    }
  `
  const requestHeaders = {
    authorization: userToken,
    Password: password
  }

  const response = await tokenAppGraphql.request(UPDATE_STATUS_MERCHANT, data, requestHeaders);
  return response.updateStatusEmployee;
}

export const getSubmerchantID = async (id) => {
  try {
    const EMPLOYEE = gql`
      query Employee($employeeId: Int) {
        Employee(id: $employeeId) {
          submerchantID
        }
      }
    `;
    const respone = await merchantServiceGraphql.request(EMPLOYEE, {
      employeeId: id,
    });
    return respone.Employee.submerchantID;
  } catch (err) {
    return null;
  }
};

export const getSubmerchantWithToken = async(token) => {
  const client = new GraphQLClient(endPoint, {
    headers: {
      authorization: 'Bearer ' + token,
    },
  })
  try {
    const EMPLOYEE = gql`
      query Employee {
        Employee {
          submerchantID
        }
      }
    `;
    const respone = await client.request(EMPLOYEE)
    return respone.Employee.submerchantID;
  } catch (err) {
    return null;
  }
}

export const updateProfile = async (id, fullName, authentype) => {
  try {
    const UPDATE_EMPLOYEE = gql`
      mutation UpdateEmployee(
        $updateEmployeeId: Int!
        $fullname: String
        $authentype: Int
      ) {
        updateEmployee(
          id: $updateEmployeeId
          fullname: $fullname
          authentype: $authentype
        ) {
          id
          username
          fullname
          phone
          email
          address
          role
          status
          authentype
          created_at
          updated_at
          SubMerchant {
            id
            merchantID
            name
          }
          terminals {
            id
            submerchantID
            contractID
            terminal_code
          }
        }
      }
    `;
    const data = {
      updateEmployeeId: id,
      fullname: fullName,
      authentype: authentype,
    };
    const response = await merchantServiceGraphql.request(
      UPDATE_EMPLOYEE,
      data
    );
    return response.updateEmployee;
  } catch (err) {
    return null;
  }
};

export const generateQRCode = async () => {
  try {
    const GENERATE_QR_CODE = gql`
      mutation GenerateQRCode {
        generateQRCode {
          imageBase
        }
      }
    `;

    const response = await merchantServiceGraphql.request(GENERATE_QR_CODE);
    return response.generateQRCode;
  } catch (err) {
    return null;
  }
};
